<template>
  <div class="render-list about">
    <CommonHeader :curNavIndex="curNavIndex"></CommonHeader>
    <div id="wrapper" class="iscroll-list painter-list">
      <div id="scroller">
        <div id="J_PullDown" class="ui-refresh-down" style="display:none;"><span class="refresh-down-label"></span></div>
        <ul id="thelist">
          <img class="loading-img" src="../../static/img/loading.gif">
        </ul>
        <div id="J_PullUp" class="ui-refresh-up" style="display:none;"><span class="refresh-up-label">More</span><img class="pull-up-img" src="../../static/img/loading.gif"></div>
      </div>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>
<script>
  import axios from 'axios';
  import {API_LIST} from '../utils/config';
  import CommonHeader from './Header';
  import CommonFooter from './Footer';

  //上拉请求标示位
  const IScroll = window.iScroll;

  let myScroll;

  let pullDownEl;
  let pullDownOffset;
  let pullUpEl;
  let pullUpOffset;

export default {
  name: 'about',
  components: {
    CommonHeader,
    CommonFooter
  },
  data () {
    return {
      curNavIndex: 2,
      aboutCont: ''
    }
  },
  methods: {
    getAboutContent: function(){
      let that = this;

      axios.post(API_LIST.aboutDetail)
        .then(function(res) {
          if (res.data.status.error_code === 0) {
            let aboutCont = res.data.bizobj.content;

            $($('#thelist')).html(`
              <div class="about-content ke-edit">
               <div class="about-desc">${aboutCont}</div>
              </div>`);

            setTimeout(function() {
              myScroll.refresh();
              }, 200);

            $('#J_CommonFooter').show();
          }else{
            $('.about-desc').html('<div class="empty-data">'+ res.data.status.error_msg +'</div>');

            $('#J_CommonFooter').show();
          }
      }.bind(this))
      .catch(function(err) {
        console.log(err);
      });
    },
    loaded: function(){
      let that = this;

      pullDownEl = $('#J_PullDown');
      pullDownOffset = pullDownEl.offset().height;
      pullUpEl = $('#J_PullUp');
      pullUpOffset = pullUpEl.offset().height;

      myScroll = new IScroll('wrapper', {
        zoom: true,
        mouseWheel: true,
        wheelAction: 'zoom',
        useTransition: true,
        onRefresh: function() {
          if (pullDownEl.hasClass('loading')) {
            pullDownEl.attr('class', '');
            pullDownEl.find('.refresh-down-label').html('');
          } else if (pullUpEl.hasClass('loading')) {
            pullUpEl.attr('class', '');
            pullUpEl.find('.refresh-up-label').html('More');
            pullUpEl.find('.pull-up-img').hide();
          }
        },
        onScrollMove: function() {
          $('#J_CommonFooter').hide();

          if (this.y > 5 && !pullDownEl.hasClass('flip')) {
            pullDownEl.attr('class', 'flip');
            pullDownEl.find('.refresh-down-label').html('');
            this.minScrollY = 0;
          } else if (this.y < 5 && pullDownEl.hasClass('flip')) {
            pullDownEl.attr('class', '');
            pullDownEl.find('.refresh-down-label').html('');
            this.minScrollY = -pullDownOffset;
          } else if (this.y < (this.maxScrollY - 5) && !pullUpEl.hasClass('flip')) {
            pullUpEl.attr('class', 'flip');
            pullUpEl.find('.refresh-up-label').html('Loading...');
            this.maxScrollY = this.maxScrollY;
          } else if (this.y > (this.maxScrollY + 5) && pullUpEl.hasClass('flip')) {
            pullUpEl.attr('class', '');
            pullUpEl.find('.refresh-up-label').html('More');

            this.maxScrollY = pullUpOffset;
          }
        },
        onScrollEnd: function() {
          $('#J_CommonFooter').show();

          if (pullDownEl.hasClass('flip')) {
            pullDownEl.attr('class', 'loading');
            pullDownEl.find('.refresh-down-label').html('');
          } else if (pullUpEl.hasClass('flip')) {
            pullUpEl.attr('class', 'loading');

            pullUpEl.find('.refresh-up-label').html('');
          }
        }
      });

      setTimeout(function() { document.getElementById('wrapper').style.left = '0';}, 800);

      $(window).resize(function () {
        myScroll.refresh();
      });
    }
  },
  created: function(){
    setTimeout(this.loaded, 200);
  },
  mounted: function(){
    this.getAboutContent();
  }
}
</script>

<style scoped>
  .about #wrapper{top:7rem;}
</style>



// WEBPACK FOOTER //
// About.vue?1ed77083